import { render } from "./AddGroupUserModal.vue?vue&type=template&id=2d66ac70&scoped=true"
import script from "./AddGroupUserModal.vue?vue&type=script&lang=js"
export * from "./AddGroupUserModal.vue?vue&type=script&lang=js"

import "./AddGroupUserModal.vue?vue&type=style&index=0&id=2d66ac70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d66ac70"]])

export default __exports__